import { fileService } from "../_services"

const root = {
  folder: { id: null, isFolder: true, name: 'Документы'},
  tag: { id: null, isTag: true, name: 'Шаблоны'}
}

const sorters = [
  { name: 'по дате', key: 'date'},
  { name: 'по названию', key: 'name'}
]

function convertToFile (item, isDoc = true) {
  return {
    id: item.id,
    name: item.name,
    date: item.updateDate,
    tags: isDoc ? item.myTags : item.tagged.map(x => x.myTag),
    folder: item.myFolder || root.folder,
    isTemplate: !isDoc,
    isDoc, 
  }
}

const convertType = {
  document: true,
  template: false
}

export default {
  namespaced: true,

  state: {
    // data
    tags: [],
    folders: [],
    documents: [],
    templates: [],

    // const
    root,
    sorters,

    // state
    path: root.folder,
    sorter: sorters[0],
    period: null,
    filterTag: null,
  },

  getters: {
    documentsByPath: ({ documents }) => path => path.id ? documents.filter(x => x.folder && x.folder.id == path.id) : documents,
    templatesByPath: ({ templates }) => path => path.id ? templates.filter(x => x.tags.findIndex(t => t.id == path.id) != -1) : templates,
    sortedFolders: ({ folders }) => folders.sort((a, b) => a.name.localeCompare(b.name)),
    sortedTags: ({ tags }) => tags.sort((a, b) => a.name.localeCompare(b.name)),
  },

  mutations: {
    // data
    setFolders: (state, payload) => {
      state.folders = payload.map(item => ({ ...item, isFolder: true }))
      console.log("Set folders", state.folders)
    },

    addFolder: ({ folders }, payload) => {
      folders.push({ ...payload, isFolder: true })
    },

    setTags: (state, payload) => {
      state.tags = payload.map(item => ({ ...item, isTag: true, hashtag: '# ' + item.name }))
    },

    setDocuments: (state, payload) => {
      state.documents = payload.map(item => convertToFile(item, convertType.document))
    },

    addDocument: ({ documents }, payload) => {
      let doc = convertToFile(payload, convertType.document)
      documents.push(doc)
    },

    removeDocument: (state, file) => {
      state.documents = state.documents.filter(f => f.id !== file.id)
    },

    replaceDocument: (state, payload) => {
      let doc = convertToFile(payload, convertType.document)
      state.documents = state.documents.map(f => f.id === doc.id ? doc : f)
    },
    
    setTemplates: (state, payload) => {
      state.templates = payload.map(item => convertToFile(item, convertType.template))
    },

    addTemplate: ({ templates }, payload) => {
      let templ = convertToFile(payload, convertType.template)
      templates.push(templ)
    },

    removeTemplate: (state, file) => {
      state.templates = state.templates.filter(f => f.id !== file.id)
    },

    replaceTemplate: (state, payload) => {
      let templ = convertToFile(payload, convertType.template)
      state.templates = state.templates.map(f => f.id === templ.id ? templ : f)
    },

    // state
    setPath: (state, payload) => {
      state.path = { ...payload }
    },

    setPeriod: (state, payload) => {
      state.period = payload
    },

    setFilterTag: (state, payload) => {
      state.filterTag = payload
    },

    setSorter: (state, payload) => {
      state.sorter = payload
    },
  },

  actions: {
    init: ({ dispatch }) => {
      dispatch('getTags')
      dispatch('getFolders')
      dispatch('getDocuments')
      dispatch('getTemplates')
    },

    getTags: ({ commit }) => {
      fileService.getMyTags().then(data => {
        commit('setTags', data || [])
      })
    },

    getFolders: ({ commit }) => {
      fileService.getMyFolders().then(data => {
        commit('setFolders', data || [])
      })
    },

    getDocuments: ({ commit }) => {
      fileService.getMyDocuments().then(data => {
        commit('setDocuments', data || [])
      })
    },

    getTemplates: ({ commit }) => {
      fileService.getMyTemplates().then(data => {
        commit('setTemplates', data || [])
      })
    },

    createFolderWithName: ({ commit }, folderName) => {
      fileService.createFolderWithName(folderName).then(data => {
        commit('addFolder', data)
      })
    },

    createDocument: ({ commit, dispatch }, obj) => {
      fileService.createDocument(obj).then(data => {
        commit('addDocument', data)
        dispatch('getTags')
      })
    },
    
    createTemplate: ({ commit, dispatch }, obj) => {
      fileService.createTemplate(obj).then(data => {
        commit('addTemplate', data)
        dispatch('getTags')
      })
    },

    // Manage file by dialog

    deleteFile: ({ commit }, file) => {
      let removeMethod = file.isTemplate ? fileService.deleteTemplate : fileService.deleteDocument
      removeMethod(file).then(() => {
        let method = file.isTemplate ? 'removeTemplate' : 'removeDocument'
        commit(method, file)
      })
    },

    renameFile: ({ commit, dispatch }, file) => {
      let renameMethod = file.isTemplate ? fileService.changeTemplate : fileService.changeDocument
      renameMethod(file).then(data => {
        let method = file.isTemplate ? 'replaceTemplate' : 'replaceDocument'
        commit(method, data)
        dispatch('getTags')
      })
    },

    copyFile: ({ commit, dispatch }, file) => {
      let { id, ...newFileObj } = file
      let copyMethod = file.isTemplate ? fileService.copyTemplate : fileService.copyDocument
      copyMethod(id, newFileObj).then(data => {
        let method = file.isTemplate ? 'addTemplate' : 'addDocument'
        commit(method, data)
        dispatch('getTags')
      })
    },

    moveFile: ({ commit }, file) => {
      fileService.changeDocument(file).then(data => {
        commit('replaceDocument', data)
      })
    },

    transformDocToTemplate: ({ commit, dispatch }, file) => {
      let { id, ...newTemplObj } = file
      fileService.transformToTemplate(id, newTemplObj).then(data => {
        commit('addTemplate', data)
        dispatch('getTags')
      })
    },

    deletePath: ({ dispatch }, { path, target = {} }) => {
      let method = path.isTag ? fileService.deleteTag : fileService.deleteFolder
      method(path.id, target.id).then(() => {
        path.isTag ? dispatch('getTags') : dispatch('getFolders')
        path.isTag ? dispatch('getTemplates') : dispatch('getDocuments')
      })
    },

    updatePath: ({ commit, state, dispatch }, path) => {
      let method = path.isTag ? fileService.renameTag : fileService.renameFolder
      method({ id: path.id, name: path.name }).then(data => {
        let baseList = path.isTag ? state.tags : state.folders
        let list = baseList.map(p => p.id === data.id ? data : p)
        path.isTag ? commit('setTags', list) : commit('setFolders', list)
        dispatch('getTemplates')
        dispatch('getDocuments')
      })
    }
  }
}